import {
    PerSellerState,
    State,
    initialPerSellerState,
    initialState,
} from "@/mk2/apps/bazaar/containers/Reviews/Reviews.reducers";
import { AppState } from "@/mk2/reducers";

export const getReviewsState = (state: AppState): State =>
    state.containers.bazaar.reviews || initialState;

export const getReviewsSellerState = (state: AppState, username: string): PerSellerState =>
    getReviewsState(state).sellers[username] || initialPerSellerState;
